import { translateKeys, translateValues } from '@atc/bonnet-parameters';
import getRequiredKeys from './getRequiredKeys';
import pageNames from './pageNames';
export default function queryPreprocessor(_ref) {
  let {
    pageName,
    query
  } = _ref;
  const requiredKeys = getRequiredKeys(pageName);

  // translate all param values to LSC format
  query = translateValues(query, {
    target: 'lsc'
  });

  // merge and translate all legacy params to LSC standard parameter keys
  // as reference data lookups are in LSC format
  query = translateKeys(query, {
    target: 'lsc'
  });

  // validate that all required query params are present
  requiredKeys.forEach(key => {
    if (!query[key]) {
      throw new Error(`${pageName} path generate requires a ${key} value in the query object`);
    }
  });
  if (pageName === pageNames.SEARCH_RESULTS) {
    // remove any previously named params that are (re)assigned to the query by the route handler
    delete query.pageType;
    delete query.allListingType;
    if (!Object.prototype.hasOwnProperty.call(query, 'listingType')) {
      query.listingType = ['ALL'];
    }
  }
  return query;
}